import {CurrencyPipe} from '@angular/common';
import {Component} from '@angular/core';
import {BASE_FUNERAL_COST} from '@emma-labs/shared/typescript';
import {CardModule} from 'primeng/card';
import {PanelModule} from 'primeng/panel';

@Component({
  selector: 'em-faq',
  templateUrl: './faq.component.html',
  imports: [CardModule, PanelModule, CurrencyPipe],
})
export class FaqComponent {
  readonly funeralCost = BASE_FUNERAL_COST;
}
